import PropTypes from 'prop-types';

import PropTypesPresenter from '../../../utils/PropTypesPresenter';

export default new PropTypesPresenter(
  {
    contactPerson: PropTypes.string,
    contactPhoneNumber: PropTypes.string,
    contactEmail: PropTypes.string,
    wiringInstructions: PropTypes.string,
  },
  {
    wiringInstructionsReadable(settings) {
      return this.wiringInstructions(settings) || '--';
    },
  }
);
